// extracted by mini-css-extract-plugin
export default {"nav":"BottomNav_nav__7sUEm","tab":"BottomNav_tab__dILtn","active":"BottomNav_active__4l86U","icon":"BottomNav_icon__mFalw","label":"BottomNav_label__WokrC"};